export const SOLUTIONS_LIST_TRYNOW = [
    "developed a few versions of TryNow. API was developed by the entire Ukrainian team from scratch",
    "built a completely serverless microservice architecture, many services, each of which was deployed on its own AWS lambda",
    "was responsible for the technical side of the  project",
    "made an excellent solution to reduce the number of messages by 95%",
    "helped speed up the process from 15-20 seconds to 5 seconds at the checkout stage",
    "developed a feature that helped speed up the interaction with a core",
]

export const SOLUTIONS_LIST_ORBIT = [
    "industry best practices and coding standards implemented to ensure a consistent and maintainable codebase",
    "regular code reviews and testing conducted throughout the development process to identify and address bugs and issues early on",
    "collaborated with other team members, including the Designer and Project Manager, to ensure that technical solutions aligned with project goals and user needs",
    "the development process and system architecture thoroughly documented to facilitate future maintenance and scalability",
    "the system continuously monitored for performance and usability issues, and any problems that arose were promptly addressed",
]

export const SOLUTIONS_LIST_GAMETECH = [
    "minimized duplicated code, using a shared KMM module for Android and iOS",
    "developed an additional level of security by using asymmetric encryption",
    "used Jira board and team technical experience to transform the customer's business tasks into technical ones",
    "analyzed problems, gave estimates, review potential risks and issues in production",
]

export const SOLUTIONS_LIST_HELLO = [
    "used wide device range and emulators for testing and developing product UI and features",
    "successfully resolved all legacy bugs using modern approaches to work with multithreading",
    "perform regular feature and regression testing ",
    "use Android Studio profiler to identify performance issues and fix them",
    "specified database migrations and performed testing on the dev builds to avoid data loss for existing users",
]

export const SOLUTIONS_LIST_CRAFT = [
    "include personalization features for users to customize their experience",
    "used debug and performance testing to make sure that queries to tables are effective",
    "made sure that clearly define steps like requirements gathering, planning, testing, deployment, documentation, and continuous support",
    "created gradual plan of model and architecture migration according to new requirements in the middle of development",
]

export const SOLUTIONS_LIST_PEDNET = [
    "had a gradual plan of investigation. This plan consists of research, engaging with the Flutter community to gain insights, exploring early code repositories of Flutter on GitHub",
    "utilized Flutter's platform channels to interact with platform-specific APIs to add native maps for iOS and Android",
    "allocated time for team members to learn Flutter and its associated tools. Provide resources such as tutorials, documentation, and training sessions",
    "made sure that we include a most variety of devices during testing that we are going to support",
]
